export interface ILicenseTransferMemberRequest {
    LicenseKey: string;
    MemberID: string;
}

export class LicenseTransferMemberRequest implements ILicenseTransferMemberRequest {
    LicenseKey: string;
    MemberID: string;
}
